/**
*  @class
*  @function FreeShipping (EU version: control/variant copy for cart test)
*/
if (!customElements.get("free-shipping")) {
  class FreeShipping extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      let control_text_el = this.querySelector(".free-shipping--text-remaining.control");
      let variant_text_el = this.querySelector(".free-shipping--text-remaining.variant");
      let amount_text = control_text_el && control_text_el.querySelector("span");
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.fullText = this.querySelector(".free-shipping--text-full");
      let isPuzzlemat = this.classList.contains("puzzlemat");
      let isCartTest = document.documentElement.classList.contains("cart_test");
      if (total < minimum) {
        percentage = total / minimum;
        let remaining = minimum - total, format = window.theme.settings.money_with_currency_format || "${{amount}}";
        if (amount_text) { amount_text.innerHTML = formatMoney(remaining, format); }
        this.fullText.style.display = "none";
        if (isCartTest && isPuzzlemat && variant_text_el) { control_text_el.style.display = "none"; variant_text_el.style.display = "block"; }
        else { if (control_text_el) control_text_el.style.display = "block"; if (variant_text_el) variant_text_el.style.display = "none"; }
      } else {
        if (control_text_el) control_text_el.style.display = "none";
        if (variant_text_el) variant_text_el.style.display = "none";
        this.fullText.style.display = "block";
      }
      this.style.setProperty("--percentage", percentage);
    }
  }
  customElements.define("free-shipping", FreeShipping);
}
